import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import SignUp from '../../../components/sign-up/sign-up'
import ErrorPopup from '../../../components/error-popup/error-popup'

export class SignUpPage extends Component {
  render() {
    const {t, errorMessage} = this.props

    return (
      <div>
        <ErrorPopup error={t(errorMessage)} extraClasses="xs-text-center" />
        <SignUp {...this.props} />
      </div>
    )
  }
}

SignUpPage.propTypes = {
  errorMessage: PropTypes.string,
  t: PropTypes.func,
}

SignUpPage.defaultProps = {
  errorMessage: null,
  t: PropTypes.func,
}

const mapStateToProps = (state) => ({
  ...state.app,
  ...state.auth,
  googleError: state.google.signInError,
  twitterError: state.twitter.signInError,
  facebookError: state.facebook.signInError,
  signInError: state.session.signInError,
  missingFields: state.session.missingFields,
  clientId: state.session.client_id,
  provider: state.session.provider,
  providerSecret: state.session.providerSecret,
  providerToken: state.session.providerToken,
})

const mapDispatchToProps = dispatch => ({
  handleAction: (type, payload) => dispatch({ type, payload }),
})

export default connect(mapStateToProps, mapDispatchToProps)(
  translate()(SignUpPage),
)



// WEBPACK FOOTER //
// ./src/containers/pages/sign-up-page/sign-up-page.js